import { ReactNode } from 'react';

/** 属性定義 */
type Props = {
  children: ReactNode;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const AtCautionLabel = ({ children }: Props) => {
  return <span className='atcautionlabel'>{children}</span>;
};
/** 初期値の設定 */
AtCautionLabel.defaultProps = {};
export default AtCautionLabel;
